import classNames from "classnames";
import React from "react";
import "./PageCoverLoader.scss";
import { ChildrenProps } from "../../types";
import { KickLogo } from "@design-system/KickLogo/KickLogo";

interface PageCoverLoaderProps extends ChildrenProps {
    backdrop?: boolean;
    logo?: boolean;
    className?: string;
}

export const PageCoverLoader: React.FC<PageCoverLoaderProps> = ({
    backdrop,
    logo = true,
    className,
    children,
}) => (
    <div
        className={classNames(
            "page-cover-loader",
            {
                "page-cover-loader--backdrop": backdrop,
            },
            className,
        )}
    >
        {logo && (
            <KickLogo
                variant="icon"
                size="sm"
                className="page-cover-loader__logo"
            />
        )}
        <span className="page-cover-loader__body">{children}</span>
    </div>
);
